import { createSlice } from "@reduxjs/toolkit";
import { summaryInitialState } from "src/models/document/document.dto";
import { getSummaryDocumentsThunk } from "../action/summary.action";

export const summarySlice = createSlice({
    name: 'summary',
    initialState: summaryInitialState,
    reducers: {
        resetSummaryState: (state) => {
            return summaryInitialState;
        }
    },
    extraReducers: (builder) => {
        // Summary Thunks
        builder
            .addCase(getSummaryDocumentsThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(getSummaryDocumentsThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.pagination = action.payload.pagination || { totalItems: 0, totalPages: 0, currentPage: 1, pageSize: 10 }; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(getSummaryDocumentsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            });
    }
});

export const { resetSummaryState } = summarySlice.actions;

export default summarySlice.reducer;